var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTamao33X33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8109 13.75H22.3503C22.7645 13.75 23.1003 13.4142 23.1003 13C23.1003 12.5858 22.7645 12.25 22.3503 12.25H14.6603C13.336 12.25 12.2603 13.3258 12.2603 14.65V22.34C12.2603 22.7542 12.596 23.09 13.0103 23.09C13.4245 23.09 13.7603 22.7542 13.7603 22.34V14.8207L45.1796 46.24H37.6603C37.246 46.24 36.9103 46.5758 36.9103 46.99C36.9103 47.4042 37.246 47.74 37.6603 47.74H45.3503C46.6745 47.74 47.7503 46.6642 47.7503 45.34V37.65C47.7503 37.2358 47.4145 36.9 47.0003 36.9C46.586 36.9 46.2503 37.2358 46.2503 37.65V45.1893L14.8109 13.75Z",
    fill: "#A7B1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9103 13.01C36.9103 12.5958 37.246 12.26 37.6603 12.26H45.3503C46.6745 12.26 47.7503 13.3358 47.7503 14.66V22.35C47.7503 22.7642 47.4145 23.1 47.0003 23.1C46.586 23.1 46.2503 22.7642 46.2503 22.35V14.8107L14.8109 46.25H22.3503C22.7645 46.25 23.1003 46.5858 23.1003 47C23.1003 47.4142 22.7645 47.75 22.3503 47.75H14.6603C13.336 47.75 12.2603 46.6742 12.2603 45.35V37.66C12.2603 37.2458 12.596 36.91 13.0103 36.91C13.4245 36.91 13.7603 37.2458 13.7603 37.66V45.1793L45.1796 13.76H37.6603C37.246 13.76 36.9103 13.4242 36.9103 13.01Z",
    fill: "#A7B1BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamao33X33);
export default __webpack_public_path__ + "static/media/TAMAÑO_33X33.9c49f829845a194595f0483761ed1989.svg";
export { ForwardRef as ReactComponent };